// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "text.sub-text.title{font-weight:700}text.sub-text.subtitle{font-weight:300!important}", ""]);
// Exports
module.exports = exports;
